<template>
  <div class="Rooms bg">
    <Header>
      <template v-slot:default>
        <div class="space"></div>
        <div class="row">
          <div class="col-lg-2" v-if="OrdersCount > 0">
            <button class="checkout" @click="$router.push('/rooms-booking')">
              <a href="#0"
                ><i class="icon_cart"></i><span> {{ OrdersCount }}</span></a
              >
            </button>
          </div>
        </div>
      </template>
    </Header>

    <div class="margin_30_40">
      <div class="card bg" style="margin-top: 12%">
        <div
          class="row justify-content-center bg"
          style="align-content: center; margin: 2%"
        >
          <div class="col-3">
            <div class="form-group">
              <DatePicker
                v-model="Filter.start"
                @input="setEndDate"
                placeholder="From Date"
                :limit="DateLimit"
              />
            </div>
          </div>
          <div class="col-3">
            <div class="form-group">
              <DatePicker
                v-model="Filter.end"
                placeholder="To Date"
                :limit="EndDateLimit"
              />
            </div>
          </div>
          <div class="col-2">
            <div class="form-group">
              <button class="btn btn-rounded btn-teal" @click="addRoomFilter()">
                Check Availability
              </button>
            </div>
          </div>
          <div class="col-3">
            <div class="form-group">
              <Multiselect
                v-model="Filter.room_type"
                :options="RoomTypes"
                label="name"
                track-by="id"
                placeholder="Select Room Type"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="banner version_2"></div>
  </div>
</template>

<script>
import Rooms from "./Rooms";
import Courosel from "@/components/base/Caurosel/index";
import { DatePicker } from "@/components/base/index";
const MyComponent = {
  template: `
        <span class="my-icon">{{ opened ? 'I am open' : ' I am closed' }}</span>
    `,
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
  },
};

import "vue-range-component/dist/vue-range-slider.css";
import axios from "@/plugins/axios";
import { Header } from "@/components/index.js";
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  name: "Home",
  data() {
    return {
      Rooms: [],
      Filter: {
        start: moment().format("YYYY-MM-DD"),
        end: moment().format("YYYY-MM-DD"),
        room_type: null,
      },
      DateLimit: [
        {
          type: "weekday",
          available: [0, 1, 2, 3, 4, 5, 6],
        },
        {
          type: "weekend",
          available: [1, 2],
        },
        {
          type: "fromto",
          from: moment().subtract(1, "days").format("YYYY-MM-DD"),
          // to: '2022-02-15'
        },
      ],
      EndDateLimit: [
        {
          type: "weekday",
          available: [0, 1, 2, 3, 4, 5, 6],
        },
        {
          type: "weekend",
          available: [1, 2],
        },
        {
          type: "fromto",
          from: moment(new Date()).subtract(1, "days").format("YYYY-MM-DD"),
          // to: '2022-02-15'
        },
      ],
      RoomTypes: [],
    };
  },

  components: {
    Header,

    DatePicker,
    Rooms,
  },
  computed: {
    ...mapGetters("orders", ["bookedRoomsIdList"]),
    ...mapGetters("orders", ["OrdersCount"]),
  },
  created() {
    this.setEndDate(new Date());
    this.fetchRoomTypes();
  },
 methods: {
  setEndDate(startDate) {
    startDate = moment(new Date(startDate));
    let Enddate = startDate.add(1, "days");
    Enddate = startDate.format("YYYY-MM-DD");
    this.EndDateLimit[2].from = startDate.subtract(1, "days");
    this.Filter.end = Enddate;
  },

  async fetchRoomTypes() {
    try {
      const res = await axios.get("hms/web/room-types");
      this.RoomTypes = res.data;
    } catch (error) {
      console.error("Failed to load room types:", error);
    }
  },

  addRoomFilter() {
    if (this.Filter.start === "" && this.Filter.end === "") {
      this.$fire({
        title: "Error",
        text: "Date Filter Cannot Be Empty",
        type: "error",
        timer: 3000,
      });
      return;
    }

    if (this.Filter.start && this.Filter.end) {
      this.$store.commit("orders/AddFilterDates", this.Filter);

      // 👉 Add room_type_id to query if selected
      const query = {};
      if (this.Filter.room_type?.id) {
        query.type = this.Filter.room_type.id;
      }

      this.$router.push({ path: "rooms", query });
    }
  },
},

};
</script>
<style scoped>
.space {
  height: 40px;
}

.bg {
  background-size: contain;
}

.margin_30_40 {
  min-height: 80vh;
  margin-top: 30px !important;
  margin-bottom: 30px !important;
  justify-content: center;
}

.vm--modal {
  position: relative;
  overflow: visible !important;
  box-sizing: border-box;
  background-color: white;
  border-radius: 3px;
  box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);
}

.modal_header,
.modal_footer {
  width: 100% !important;

  left: 0px !important;
}

* {
  list-style: none;
}

.booked {
  filter: grayscale(1);
}

.checkout {
  width: 100%;
  height: 38px;
  color: aquamarine;
  background-color: #ffffff;
  border-radius: 31px;
}

.checkout:active {
  width: 100%;
  height: 38px;
  color: aquamarine !important;
  background-color: #ffffff !important;
  border-radius: 31px;
}

.btn-teal {
  background: #76c659 !important;
  color: white !important;
}
</style>

<style lang="scss" scoped>
#Home {
  img {
    max-width: 400px;
  }
}

.info2 {
  position: absolute;
  background-color: black;
  background-color: #4ccc2c !important;
  left: 15px;
  top: 40px !important;
}

.strip figure {
  height: 250px;
}
</style>
